import { createContext, useContext, useState } from "react"

const PatientContext = createContext()

export function PatientProvider({ children }) {
  const [patient, setPatient] = useState(null)

  return (
    <PatientContext.Provider value={{ patient, setPatient }}>
      {children}
    </PatientContext.Provider>
  )
}

export function usePatient() {
  return useContext(PatientContext)
}